<!-- рекурсивный компонент для визуализации дерева -->
<template>
    <div :class="{ 'zero-children-node-indent': !getNodeChildren.length }">
        <div v-if="!rootNode" :class="['node-view-line', checkboxNodeModeClass, viewLineNodeModeClass]"
        >
          <img v-if="node.value.obj.srcImg" :src="node.value.obj.srcImg" class="node-view-line__img" alt="img" />
            <span v-if="isNodeExpandable"
                  id="expandSignId"
                  ref="expandSignId"
                  :class="['node-view-line-expander', { expanded: node.value.isExpanded }]"
                  @click="$emit('expand-node', nodeDescription)">
            </span>
            <HighLightedCheckBox
                 :nodeValue="node.value"
                 :searchText="searchText"
                 :mode="{highlight}"
                 :old-design="oldDesign"
                 :styled="isNodeFullyChosen ? {styleType: 'bold'} : {}"
                 :innerCheckboxMode="innerCheckboxMode"
                 @choose-node="choose"
                 :class="[nodeClass, nodeMark]"
            />
        </div>

        <ul v-if="acceptChildrenMounting" :class="[ulClass, ulNodeModeClass]">
            <Node v-for="(child, index) in getNodeChildren"
                  :key="index"
                  :node="child"
                  :old-design="oldDesign"
                  :expandable="expandable"
                  :highlight="highlight"
                  :searchText="searchText"
                  :withImportantNodes="withImportantNodes"
                  :innerCheckboxMode="innerCheckboxMode"
                  :view-line-node-mode="viewLineNodeMode"
                  :second-node-mode="secondNodeMode"
                  @expand-node="expand"
                  @choose-node="choose"
                  :important-node-mode="importantNodeMode"
                  :checkbox-node-mode="checkboxNodeMode"
                  :additional-node-mode="additionalNodeMode"
                  :close-btn="closeBtn"
                  :extra-node-mode="extraNodeMode"
                  :chosen-node-mode="node.value.isPartiallyChosen || rootNode ? chosenNodeMode: []"
                  :ul-node-mode="ulNodeMode"
            />
            <div
                class="closeBtn"
                v-if="showBtn"
                @click="visible=true"
            >
              {{ getTextForBtn }}
            </div>
        </ul>
    </div>
</template>

<script>
    import NodeStructure from "../../data_structures/Node";
    import plural from 'plural-ru';
    import HighLightedCheckBox from "../hightlightedCheckbox/HighLightedCheckBox"

    export default {
        name: "Node",
        components: {HighLightedCheckBox},
        data() {
          return {
            visible: false,
          }
        },
        props: {
            node: {
                type: NodeStructure,
                required: true,
            },
            expandable: {
                type: Boolean,
                default: true,
            },
            highlight: {
                type: Boolean,
                default: true,
            },
            searchText: {
                type: String,
                default: '',
            },
            withImportantNodes: {
                type: Boolean,
                default: false,
            },

            oldDesign: {
                type: Boolean,
                required: false,
                default: false,
            },

            innerCheckboxMode: {
              type: Array,
            },

            /* Мод добавляет стили к объектам, у которых important: true. См. пример в App.vue*/
            importantNodeMode: {
              type: Array,
              default: () => [],
            },
            /* Мод добавляет стили к объектам, у которых extra: true. Работает аналогично
            * Important. Сделано два пропса, что бы в одном дереве использовать с разными стилями
            * города. Например, у каждой столицы (important) свои стили и у каждого региона (extra) свои стили.
            *  Пример, App.vue. */
            extraNodeMode: {
              type: Array,
              default: () => [],
            },

            additionalNodeMode: {
              type: Array,
              default: () => [],
            },

            secondNodeMode: {
              type: Array,
              default: () => [],
            },

            /* Мод для изменения стилей у node-view-line (обертка вокруг чекбокса) */
            checkboxNodeMode: {
              type: Object,
              default: null,
            },

            /* Мод для изменения стилей у node-view-line (обертка вокруг чекбокса),
              можно задать через флаги к отдельным элементам */
            viewLineNodeMode: {
              type: Array,
              default: () => [],
            },

            /* Кнопка скрытия части списка. См пример App.vue */
            closeBtn: {
              type: Object,
              default: null,
            },

            /* Мод для изменения стилей выбранных чекбоксов. Пример, App.vue */
            chosenNodeMode: {
              type: Array,
              default: () => [],
            },

            /* Мод для изменения списка чекбоксов. Пример App.vue */
            ulNodeMode: {
              type: Object,
              default: null,
            },
        },

        computed: {
            rootNode() {
                return (this.node.value.nodeLevel === 0);
            },
            isNodeExpandable() {
                return (this.node.children.length > 0 && this.expandable && !this.node.value.expandable);
            },
            nodeDescription() {
                return {
                    level: this.node.value.nodeLevel,
                    id: this.node.value.obj.id
                };
            },
            isNodeFullyChosen() {
                return (this.node.value.isChosen && !this.node.value.isPartiallyChosen);
            },
            acceptChildrenMounting() {
                return (this.node.value.isExpanded && this.node.children.length > 0);
            },
            nodeClass() {
                let classes = {};

                this.importantNodeMode.forEach((mode) => {
                  classes[mode] = this.node.value.obj.important && this.withImportantNodes;
                })
                this.extraNodeMode.forEach((mode) => {
                  classes[mode] = this.node.value.obj.extra;
                })
                this.additionalNodeMode.forEach((mode) => {
                  classes[mode] = this.node.value.obj.additional;
                })

                if (this.importantNodeMode.length === 0) {
                  classes['node-important'] = this.withImportantNodes && this.node.value.obj.important;
                }

                return classes;
            },
            ulClass() {
                return {
                    'tree-ul': true,
                    'tree-ul-root': this.rootNode,
              }
            },

            nodeMark() {
              return {
                'node-mark': this.node.value.isChosen && !this.node.value.isPartiallyChosen && this.chosenNodeMode.includes('mark'),
              }
            },

            // класс из пропса добавляется ко всем элементам, если задано 0,
            // иначе только к тому уровню, который указан в объекте
            checkboxNodeModeClass() {
              let classes = {};

              if (this.checkboxNodeMode !== null) {
                for (let key in this.checkboxNodeMode) {
                  if (this.checkboxNodeMode[key] === 0) {
                    classes[key] = true;
                  } else {
                    classes[key] = this.checkboxNodeMode[key] === this.node.value.nodeLevel;
                  }
                }
              }

              return classes;
            },

            viewLineNodeModeClass() {
              let classes = {};
              let sameClasses = [].concat(
                  this.viewLineNodeMode,
                  this.secondNodeMode,
              ).filter((mode, index, arr) => arr.indexOf(mode) !== index);

              this.viewLineNodeMode.forEach((mode) => {
                classes[mode] = this.withImportantNodes && this.node.value.obj.main;
              })
              this.secondNodeMode.forEach((mode) => {
                classes[mode] = this.node.value.obj.second;
              })
              sameClasses.forEach((mode) => {
                classes[mode] = this.withImportantNodes &&
                    (
                        this.node.value.obj.main ||
                        this.node.value.obj.second
                    )
              })

              return classes;
            },

            ulNodeModeClass() {
              let classes = {};

              if (this.ulNodeMode !== null) {
                for (let key in this.ulNodeMode) {
                  if (this.ulNodeMode[key] === 0) {
                    classes[key] = true;
                  } else {
                    classes[key] = this.ulNodeMode[key] === this.node.value.nodeLevel;
                  }
                }
              }

              return classes;
            },

            showBtn() {
              return this.closeBtn
                && this.node.value.nodeLevel === this.closeBtn.nodeLevel
                && this.node.children.length > this.closeBtn.maxVisibleItems
                && !this.visible;
            },

            getNodeChildren() {
              if (this.showBtn) {
                return this.node.children.slice(0, this.closeBtn.maxVisibleItems);
              }

              return this.node.children;
            },

            getRemainderItems() {
              return this.node.children.length - this.closeBtn.maxVisibleItems;
            },

            getTextForBtn() {
              return '... и еще ' + this.getRemainderItems + ' ' + plural(this.getRemainderItems, ...this.closeBtn.textBtn) + '.';
            },
        },

        methods: {
            expand (nodeDescription) {
                this.$emit('expand-node', nodeDescription);
            },
            choose (nodeDescription) {
                this.$emit('choose-node', nodeDescription);
            }
        },
    }
</script>

<style scoped src="../node/Node.css">
</style>
